export default __webpack_public_path__ + "static/media/digital.4bf917d8.jpg";